// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"t5yJlzjduvRcSEWgrtv9rA==","TrashButton":"fxK8drN5iZFyQ0xr46lpbw==","SaveBtn":"wXJzSBtyHcl3zh-DV-PkhA==","inputClass":"ZXmxaai6okNr7uR2lK4Ixw=="};